import { createElement } from "./dom_utils.js";

class Modal {
  constructor() {
    this.overlay = null;
    this.container = null;
    this.modalWrapper = null;
    this.closeCallback = null;
  }

  open(content, options = {}) {
    if (this.overlay) this.close();

    this.overlay = createElement("div", {
      style: `
        position: fixed;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background: rgba(0, 0, 0, 0.8);
        display: flex;
        justify-content: center;
        align-items: center;
        z-index: 2147483648;
        opacity: 0;
        transition: opacity 0.3s ease;
      `,
    });

    const modalWrapper = createElement("div", {
      style: `
        position: relative;
        transform: scale(0.9);
        transition: transform 0.3s ease;
      `,
    });

    this.container = createElement("div", {
      style: `
        position: relative;
        max-width: 95vw;
        max-height: 90vh;
        background: #fff;
        border-radius: 12px;
        overflow: auto;
      `,
    });

    const closeButton = createElement("div", {
      style: `
        position: absolute;
        top: -40px;
        right: 0;
        background: #fff;
        border: none;
        border-radius: 50%;
        display: flex;
        padding: 8px;
        align-items: center;
        justify-content: center;
        cursor: pointer;
        z-index: 1;
      `,
    });
    closeButton.innerHTML = `<svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M18 6L6 18M6 6L18 18" stroke="#666" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
    </svg>`;
    closeButton.addEventListener("click", () => this.close());

    if (typeof content === "string") {
      this.container.innerHTML = content;
    } else {
      this.container.appendChild(content);
    }

    modalWrapper.appendChild(closeButton);
    modalWrapper.appendChild(this.container);
    this.overlay.appendChild(modalWrapper);
    document.body.appendChild(this.overlay);

    this.overlay.addEventListener("click", (e) => {
      if (e.target === this.overlay) this.close();
    });

    setTimeout(() => {
      this.overlay.style.opacity = "1";
      modalWrapper.style.transform = "scale(1)";
    }, 10);

    if (options.onClose) {
      this.closeCallback = options.onClose;
    }

    this.modalWrapper = modalWrapper;
  }

  close() {
    if (!this.overlay) return;

    this.overlay.style.opacity = "0";
    if (this.modalWrapper) {
      this.modalWrapper.style.transform = "scale(0.9)";
    }

    setTimeout(() => {
      if (this.overlay && this.overlay.parentNode) {
        this.overlay.parentNode.removeChild(this.overlay);
      }
      this.overlay = null;
      this.container = null;
      this.modalWrapper = null;

      if (this.closeCallback) {
        this.closeCallback();
        this.closeCallback = null;
      }
    }, 300);
  }
}

export default Modal;

